var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_3449)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_331_3449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.475 0 0 4.47751 0 10C0 14.4192 2.865 18.1667 6.8375 19.4875C7.3375 19.5817 7.52083 19.2725 7.52083 19.0067C7.52083 18.7692 7.5125 18.14 7.50833 17.3067C4.72667 17.91 4.14 15.965 4.14 15.965C3.685 14.8109 3.0275 14.5025 3.0275 14.5025C2.12167 13.8825 3.0975 13.895 3.0975 13.895C4.10167 13.965 4.62917 14.925 4.62917 14.925C5.52083 16.4542 6.97 16.0125 7.54167 15.7567C7.63167 15.11 7.88917 14.6692 8.175 14.4192C5.95417 14.1692 3.62 13.3092 3.62 9.47752C3.62 8.38585 4.0075 7.49418 4.64917 6.79418C4.53667 6.54168 4.19917 5.52501 4.73667 4.14751C4.73667 4.14751 5.57417 3.87917 7.48667 5.17251C8.28667 4.95001 9.13667 4.84001 9.98667 4.83501C10.8367 4.84001 11.6867 4.95001 12.4867 5.17251C14.3867 3.87917 15.2242 4.14751 15.2242 4.14751C15.7617 5.52501 15.4242 6.54168 15.3242 6.79418C15.9617 7.49418 16.3492 8.38585 16.3492 9.47752C16.3492 13.3192 14.0117 14.165 11.7867 14.4109C12.1367 14.7109 12.4617 15.3242 12.4617 16.2609C12.4617 17.5992 12.4492 18.6742 12.4492 18.9992C12.4492 19.2617 12.6242 19.5742 13.1367 19.4742C17.1375 18.1625 20 14.4125 20 10C20 4.47751 15.5225 0 10 0Z",
    fill: "#777E90"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_3449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_331_3449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.5048,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.2514985d73b5eaacb0863f14502e11d5.svg";
export { ForwardRef as ReactComponent };